<template>
  <v-btn
    :disabled="disabled || isTimeoutSet"
    :class="[btnClass]"
    @click="evOnClick"
  >
    <i :class="['fas', 'mr-2', 'text-twenty', iconClass]"></i>
    {{ btnText }}
  </v-btn>
</template>

<script>
export default {
  name: "VBtnTimeout",

  props: {
    /** Classes adicionais para o botão. Padrão: btn-save */
    btnClass: { type: String, default: "btn-save" },
    /** Classes adicionais para o ícone. Padrão: fa-save */
    iconClass: { type: String, default: "fa-save" },
    /** Texto enquanto botão está reiniciando. $TIMEOUT é substituído pelo tempo restante. Padrão: AGUARDE $TIMEOUTs */
    timeoutText: { type: String, default: "AGUARDE $TIMEOUTs" },
    /** Texto quando disabled=true */
    disabledText: { type: String, default: "CARREGANDO" },
    text: { Type: String, default: "SALVAR" },
    /** Segundos até reativar botão. Padrão: 30 */
    timeout: { Type: Number, default: 30 },
    /** Desativa o botão */
    disabled: Boolean,
  },

  data() {
    return {
      interval: null,
      secondsLeft: 0,
    };
  },

  computed: {
    isTimeoutSet() {
      return this.secondsLeft > 0;
    },

    btnText() {
      if (this.isTimeoutSet)
        return this.timeoutText.replace("$TIMEOUT", String(this.secondsLeft));
      else if (this.disabled) return this.disabledText;
      else return this.text;
    },
  },

  watch: {
    secondsLeft() {
      if (this.secondsLeft > 0) {
        clearTimeout(this.interval);
        this.interval = setTimeout(() => {
          this.secondsLeft--;
        }, 1000);
      } else clearTimeout(this.interval);
    },

    timeout() {
      this.startTimeout();
    },
  },

  methods: {
    startTimeout() {
      this.secondsLeft = this.timeout;
    },

    async evOnClick() {
      this.startTimeout();
      this.$emit("click");
    },
  },
};
</script>

<style>
</style>